import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=03fb7f88&"
import script from "./upload-image.vue?vue&type=script&lang=js&"
export * from "./upload-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports